import { render } from "./WCMobileContextMenuRoot.vue?vue&type=template&id=77170ac8&scoped=true"
import script from "./WCMobileContextMenuRoot.vue?vue&type=script&lang=js"
export * from "./WCMobileContextMenuRoot.vue?vue&type=script&lang=js"

import "./WCMobileContextMenuRoot.vue?vue&type=style&index=0&id=77170ac8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77170ac8"]])

export default __exports__